export const CREATE_CAMPAIGN = 'createCampaign';
